msgid ""
msgstr ""
"POT-Creation-Date: 2026-10-01 19:06+0200\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"

#. placeholder {0}: interest.label
#: src/pages/interests/membership.tsx
msgid "“{0}” added to your interests"
msgstr "“{0}” added to your interests"

#: src/pages/help/help-page.tsx
msgid "[{letsName}] Bug report"
msgstr "[{letsName}] Bug report"

#: src/pages/help/help-page.tsx
msgid "[{letsName}] Help request"
msgstr "[{letsName}] Help request"

#: src/pages/help/help-page.tsx
msgid "[{letsName}] Suggestion"
msgstr "[{letsName}] Suggestion"

#. placeholder {0}: members.length
#: src/pages/interests/interest-page.tsx
#: src/pages/interests/interests-page.tsx
msgid "{0, plural, one {# member} other {# members}}"
msgstr "{0, plural, one {# member} other {# members}}"

#. placeholder {0}: coming.length
#: src/pages/events/details/participants.tsx
msgid "{0, plural, one {# participant} other {# participants}}"
msgstr "{0, plural, one {# participant} other {# participants}}"

#. placeholder {0}: data.total
#: src/pages/home/open-requests-card.tsx
msgid "{0, plural, other {See all # open requests}}"
msgstr "{0, plural, other {See all # open requests}}"

#. placeholder {0}: data.total
#: src/pages/home/pending-transactions-card.tsx
msgid "{0, plural, other {See all # pending exchanges}}"
msgstr "{0, plural, other {See all # pending exchanges}}"

#: src/components/comments-section.tsx
#: src/pages/requests/list/requests-list.tsx
msgid "{commentsCount, plural, one {# comment} other {# comments}}"
msgstr "{commentsCount, plural, one {# comment} other {# comments}}"

#. placeholder {0}: <> {formatted} <Unit /> </>
#. placeholder {1}: <> {formatted} <Unit plural /> </>
#: src/components/amount.tsx
msgid "{count, plural, one {{0}} other {{1}}}"
msgstr "{count, plural, one {{0}} other {{1}}}"

#: src/pages/requests/details/request-answer.tsx
msgid "{firstName} knows you aren't available."
msgstr "{firstName} knows you aren't available."

#: src/pages/requests/details/request-answer.tsx
msgid "{firstName} will be notified of your answer."
msgstr "{firstName} will be notified of your answer."

#: src/pages/members/details/member-sidebar.tsx
msgid "{months, plural, one {# month} other {# months}}"
msgstr "{months, plural, one {# month} other {# months}}"

#: src/components/attachments.tsx
msgid "{name} couldn't be attached. Try again in a few moments."
msgstr "{name} couldn't be attached. Try again in a few moments."

#: src/components/transaction-dialog.tsx
msgid "{name} doesn't need to confirm: the exchange is completed right away."
msgstr "{name} doesn't need to confirm: the exchange is completed right away."

#: src/pages/members/details/overview-tab.tsx
msgid "{name} hasn't chosen any interest yet."
msgstr "{name} hasn't chosen any interest yet."

#: src/pages/members/details/overview-tab.tsx
msgid "{name} hasn't written a bio yet."
msgstr "{name} hasn't written a bio yet."

#: src/components/attachments.tsx
msgid "{name} is larger than 10 MB and wasn't attached"
msgstr "{name} is larger than 10 MB and wasn't attached"

#: src/components/transaction-dialog.tsx
msgid "{name} needs to confirm to complete the exchange."
msgstr "{name} needs to confirm to complete the exchange."

#: src/pages/members/details/exchanges-tab.tsx
msgid "{name}'s exchanges will appear here."
msgstr "{name}'s exchanges will appear here."

#: src/pages/members/details/activity-tab.tsx
msgid "{name}'s requests, events and offers to help will appear here."
msgstr "{name}'s requests, events and offers to help will appear here."

#: src/pages/events/list/events-list.tsx
msgid "{participantsCount, plural, one {# participant} other {# participants}}"
msgstr "{participantsCount, plural, one {# participant} other {# participants}}"

#: src/pages/home/open-requests-card.tsx
#: src/pages/requests/details/request-page.tsx
msgid "{positiveAnswersCount, plural, one {# member can help} other {# members can help}}"
msgstr "{positiveAnswersCount, plural, one {# member can help} other {# members can help}}"

#: src/pages/members/details/activity-tab.tsx
msgid "{total, plural, one {# activity} other {# activities}}"
msgstr "{total, plural, one {# activity} other {# activities}}"

#: src/pages/events/list/events-list.tsx
msgid "{total, plural, one {# event} other {# events}}"
msgstr "{total, plural, one {# event} other {# events}}"

#: src/pages/members/details/exchanges-tab.tsx
msgid "{total, plural, one {# exchange} other {# exchanges}}"
msgstr "{total, plural, one {# exchange} other {# exchanges}}"

#: src/pages/information/list/information-list.tsx
msgid "{total, plural, one {# piece of information} other {# pieces of information}}"
msgstr "{total, plural, one {# piece of information} other {# pieces of information}}"

#: src/pages/home/feed.tsx
msgid "{total, plural, one {# publication} other {# publications}}"
msgstr "{total, plural, one {# publication} other {# publications}}"

#: src/pages/requests/list/requests-list.tsx
msgid "{total, plural, one {# request} other {# requests}}"
msgstr "{total, plural, one {# request} other {# requests}}"

#: src/pages/members/details/member-sidebar.tsx
msgid "{years, plural, one {# year} other {# years}}"
msgstr "{years, plural, one {# year} other {# years}}"

#: src/pages/home/profile-completion/07-bio-step.tsx
msgid "A few words about you help the other members get to know you."
msgstr "A few words about you help the other members get to know you."

#: src/pages/requests/request-form.tsx
msgid "A few words, for example: Help to put up a shelf"
msgstr "A few words, for example: Help to put up a shelf"

#: src/pages/information/information-form.tsx
msgid "A few words, for example: Next general assembly"
msgstr "A few words, for example: Next general assembly"

#: src/pages/events/event-form.tsx
msgid "A few words, for example: Picnic at the lake"
msgstr "A few words, for example: Picnic at the lake"

#: src/pages/help/help-page.tsx
#: src/pages/home/feedback-card.tsx
msgid "A problem, an idea?"
msgstr "A problem, an idea?"

#: src/pages/home/feedback-card.tsx
msgid "A question about the application"
msgstr "A question about the application"

#: src/pages/help/help-page.tsx
msgid "A question, something you can't manage to do? Write to us, we'll answer you."
msgstr "A question, something you can't manage to do? Write to us, we'll answer you."

#: src/pages/members/details/overview-tab.tsx
msgid "About"
msgstr "About"

#: src/pages/profile/bio-section.tsx
msgid "About me"
msgstr "About me"

#: src/components/transaction-item.tsx
msgid "Accept"
msgstr "Accept"

#: src/pages/members/details/member-page.tsx
#: src/pages/members/details/overview-tab.tsx
msgid "Activity"
msgstr "Activity"

#: src/pages/home/profile-completion/05-address-step.tsx
#: src/pages/interests/membership.tsx
msgid "Add"
msgstr "Add"

#. placeholder {0}: interest.label
#: src/pages/interests/membership.tsx
msgid "Add “{0}” to your interests"
msgstr "Add “{0}” to your interests"

#: src/pages/interests/membership.tsx
msgid "Add a note"
msgstr "Add a note"

#: src/pages/home/profile-completion/06-avatar-step.tsx
msgid "Add a photo"
msgstr "Add a photo"

#: src/components/attachments.tsx
msgid "Add files"
msgstr "Add files"

#: src/pages/home/profile-completion/02-contact-info-step.tsx
msgid "Add my phone number"
msgstr "Add my phone number"

#: src/pages/members/details/member-sidebar.tsx
msgid "Add to my contacts"
msgstr "Add to my contacts"

#: src/pages/interests/membership.tsx
msgid "Add to my interests"
msgstr "Add to my interests"

#: src/pages/home/profile-completion/02-contact-info-step.tsx
msgid "Add your phone number"
msgstr "Add your phone number"

#: src/pages/members/details/member-sidebar.tsx
#: src/pages/profile/address-section.tsx
msgid "Address"
msgstr "Address"

#: src/components/address-form-dialog.tsx
#: src/pages/profile/address-section.tsx
msgid "Address complement (optional)"
msgstr "Address complement (optional)"

#: src/components/address-search.tsx
msgid "Addresses found"
msgstr "Addresses found"

#: src/pages/events/list/events-filters.tsx
msgctxt "events filter"
msgid "All"
msgstr "All"

#: src/pages/members/details/exchanges-tab.tsx
msgctxt "exchanges filter"
msgid "All"
msgstr "All"

#: src/pages/home/feed.tsx
msgctxt "feed filter"
msgid "All"
msgstr "All"

#: src/pages/requests/list/requests-filters.tsx
msgctxt "requests filter"
msgid "All"
msgstr "All"

#: src/pages/events/details/notify-dialog.tsx
msgid "All members"
msgstr "All members"

#: src/pages/help/help-page.tsx
msgid "All the members of the LETS."
msgstr "All the members of the LETS."

#: src/pages/home/profile-completion/04-notifications-step.tsx
msgid "Allow"
msgstr "Allow"

#: src/pages/settings/settings-page.tsx
msgid "Allow notifications to receive them here too."
msgstr "Allow notifications to receive them here too."

#: src/pages/home/push-notifications-prompt.tsx
#: src/pages/settings/settings-page.tsx
msgid "Allow on this device"
msgstr "Allow on this device"

#: src/components/transaction-dialog.tsx
msgid "Amount"
msgstr "Amount"

#: src/pages/events/event-form.tsx
msgid "An event of the LETS, for its members."
msgstr "An event of the LETS, for its members."

#: src/pages/events/event-form.tsx
msgid "An event organized by others, that you share with the members."
msgstr "An event organized by others, that you share with the members."

#: src/pages/help/help-page.tsx
#: src/pages/home/feedback-card.tsx
msgid "An improvement, a clearer wording…"
msgstr "An improvement, a clearer wording…"

#: src/pages/error-page.tsx
msgid "An unexpected error happened"
msgstr "An unexpected error happened"

#: src/pages/requests/details/request-answers.tsx
msgid "Answers"
msgstr "Answers"

#: src/pages/settings/settings-page.tsx
msgid "Appearance"
msgstr "Appearance"

#: src/pages/settings/settings-page.tsx
msgid "Applies to this device only."
msgstr "Applies to this device only."

#: src/components/rich-text-toolbar.tsx
msgid "Apply"
msgstr "Apply"

#: src/pages/events/details/participation.tsx
msgid "Are you coming?"
msgstr "Are you coming?"

#: src/pages/requests/create/create-request-page.tsx
msgid "Ask members for help: they'll be notified and can offer theirs."
msgstr "Ask members for help: they'll be notified and can offer theirs."

#: src/pages/help/help-page.tsx
msgid "Asking for a service"
msgstr "Asking for a service"

#: src/components/rich-text-toolbar.tsx
msgid "Attach files"
msgstr "Attach files"

#: src/pages/events/event-form.tsx
#: src/pages/information/information-form.tsx
#: src/pages/requests/request-form.tsx
msgid "Attachments"
msgstr "Attachments"

#: src/pages/members/details/activity-item.tsx
msgid "Attended {link}"
msgstr "Attended {link}"

#: src/pages/members/details/activity-item.tsx
msgid "Attends {link}"
msgstr "Attends {link}"

#: src/components/transaction-dialog.tsx
#: src/pages/authentication/authentication.tsx
#: src/pages/events/edit/edit-event-page.tsx
#: src/pages/information/edit/edit-information-page.tsx
#: src/pages/requests/details/requester-actions.tsx
#: src/pages/requests/edit/edit-request-page.tsx
msgid "Back"
msgstr "Back"

#: src/pages/error-page.tsx
msgid "Back to home"
msgstr "Back to home"

#: src/pages/members/details/exchanges-tab.tsx
#: src/pages/members/details/overview-tab.tsx
#: src/pages/profile/profile-page.tsx
msgid "Balance"
msgstr "Balance"

#: src/pages/profile/bio-section.tsx
msgid "Bio"
msgstr "Bio"

#: src/components/rich-text-toolbar.tsx
msgid "Bold"
msgstr "Bold"

#: src/components/rich-text-toolbar.tsx
msgid "Bulleted list"
msgstr "Bulleted list"

#: src/pages/home/profile-completion/04-notifications-step.tsx
#: src/pages/settings/settings-page.tsx
msgid "By email"
msgstr "By email"

#: src/pages/requests/details/request-answers.tsx
msgid "Can help"
msgstr "Can help"

#: src/pages/help/help-page.tsx
msgid "Can I reply to a notification email?"
msgstr "Can I reply to a notification email?"

#: src/pages/requests/details/request-answer.tsx
msgid "Can you help?"
msgstr "Can you help?"

#: src/pages/requests/details/request-answers.tsx
msgid "Can't help"
msgstr "Can't help"

#: src/components/address-form-dialog.tsx
#: src/components/rich-text-toolbar.tsx
#: src/components/transaction-dialog.tsx
#: src/pages/events/details/notify-dialog.tsx
#: src/pages/events/event-form.tsx
#: src/pages/interests/membership.tsx
#: src/pages/profile/profile-section.tsx
msgid "Cancel"
msgstr "Cancel"

#: src/pages/requests/details/requester-actions.tsx
msgid "Cancel the request"
msgstr "Cancel the request"

#. placeholder {0}: request.title
#: src/pages/requests/details/requester-actions.tsx
msgid "Cancel the request “{0}”?"
msgstr "Cancel the request “{0}”?"

#: src/pages/home/feed.tsx
#: src/pages/requests/list/requests-list.tsx
msgid "Canceled"
msgstr "Canceled"

#: src/components/transaction-dialog.tsx
msgid "Change"
msgstr "Change"

#: src/components/transaction-dialog.tsx
msgid "Change the member"
msgstr "Change the member"

#: src/pages/profile/identity-section.tsx
msgid "Change the photo"
msgstr "Change the photo"

#: src/components/api-result.tsx
#: src/pages/error-page.tsx
msgid "Check your internet connection, then try again."
msgstr "Check your internet connection, then try again."

#: src/pages/home/profile-completion/06-avatar-step.tsx
msgid "Choose a photo"
msgstr "Choose a photo"

#: src/pages/events/event-form.tsx
msgid "Choose an address from the list below"
msgstr "Choose an address from the list below"

#: src/pages/interests/interests-page.tsx
msgid "Choose your interests to meet the members who share them."
msgstr "Choose your interests to meet the members who share them."

#: src/components/address-form-dialog.tsx
#: src/pages/profile/address-section.tsx
msgid "City"
msgstr "City"

#: src/pages/events/list/events-list.tsx
#: src/pages/home/feed.tsx
#: src/pages/information/list/information-list.tsx
#: src/pages/members/list/members-list.tsx
#: src/pages/requests/list/requests-list.tsx
msgid "Clear filters"
msgstr "Clear filters"

#: src/components/address-form-dialog.tsx
#: src/components/rich-text-toolbar.tsx
#: src/components/toaster.tsx
#: src/pages/events/details/notify-dialog.tsx
#: src/pages/home/push-notifications-prompt.tsx
#: src/pages/interests/membership.tsx
#: src/pages/requests/details/requester-actions.tsx
msgid "Close"
msgstr "Close"

#: src/pages/requests/details/requester-actions.tsx
msgid "Close it once you have been helped, or cancel it if you no longer need help."
msgstr "Close it once you have been helped, or cancel it if you no longer need help."

#: src/pages/requests/details/requester-actions.tsx
msgid "Close the request"
msgstr "Close the request"

#. placeholder {0}: request.title
#: src/pages/requests/details/requester-actions.tsx
msgid "Close the request “{0}”?"
msgstr "Close the request “{0}”?"

#: src/pages/events/list/events-list.tsx
msgid "Coming"
msgstr "Coming"

#: src/components/transaction-dialog.tsx
msgid "Comment"
msgstr "Comment"

#: src/components/transaction-dialog.tsx
msgid "Comment (optional)"
msgstr "Comment (optional)"

#: src/pages/members/details/activity-item.tsx
msgid "Commented on {link}"
msgstr "Commented on {link}"

#: src/components/comments-section.tsx
#: src/pages/members/details/activity-tab.tsx
msgid "Comments"
msgstr "Comments"

#: src/pages/members/list/members-list.tsx
msgid "Committee"
msgstr "Committee"

#: src/pages/events/event-form.tsx
msgid "Committee meeting"
msgstr "Committee meeting"

#: src/pages/members/details/member-sidebar.tsx
#: src/pages/members/list/members-list.tsx
msgid "Committee member"
msgstr "Committee member"

#: src/pages/members/list/members-page.tsx
msgid "Committee members"
msgstr "Committee members"

#: src/layout/layout.tsx
#: src/pages/navigation.tsx
msgid "Community"
msgstr "Community"

#: src/pages/members/details/exchanges-tab.tsx
msgctxt "exchanges filter"
msgid "Completed"
msgstr "Completed"

#: src/components/transaction-dialog.tsx
msgid "Confirmation"
msgstr "Confirmation"

#: src/pages/members/details/member-sidebar.tsx
#: src/pages/profile/contact-section.tsx
msgid "Contact"
msgstr "Contact"

#: src/pages/requests/details/request-answer.tsx
msgid "Contact {firstName} to arrange the details."
msgstr "Contact {firstName} to arrange the details."

#: src/pages/help/help-page.tsx
#: src/pages/members/details/member-sidebar.tsx
msgid "Copy the email address"
msgstr "Copy the email address"

#: src/pages/members/details/member-sidebar.tsx
msgid "Copy the phone number"
msgstr "Copy the phone number"

#: src/pages/events/create/create-event-page.tsx
#: src/pages/events/list/events-list.tsx
msgid "Create an event"
msgstr "Create an event"

#: src/pages/events/create/create-event-page.tsx
msgid "Create the event"
msgstr "Create the event"

#: src/pages/settings/settings-page.tsx
msgid "Dark"
msgstr "Dark"

#: src/pages/events/event-form.tsx
msgid "Date and time (optional)"
msgstr "Date and time (optional)"

#: src/pages/events/details/event-page.tsx
#: src/pages/events/list/events-list.tsx
#: src/pages/home/feed.tsx
msgid "Date to be decided"
msgstr "Date to be decided"

#: src/components/transaction-item.tsx
msgid "Decline"
msgstr "Decline"

#: src/pages/members/details/exchanges-tab.tsx
msgctxt "exchanges filter"
msgid "Declined"
msgstr "Declined"

#: src/pages/settings/settings-page.tsx
msgid "Demo"
msgstr "Demo"

#: src/components/transaction-dialog.tsx
msgid "Details"
msgstr "Details"

#: src/app/routes.ts
#: src/pages/documents/documents-page.tsx
msgid "Documents"
msgstr "Documents"

#: src/pages/events/details/organizer-actions.tsx
#: src/pages/events/event-form.tsx
#: src/pages/home/profile-completion/01-name-step.tsx
#: src/pages/information/details/information-details-page.tsx
#: src/pages/profile/profile-section.tsx
#: src/pages/requests/details/requester-actions.tsx
msgid "Edit"
msgstr "Edit"

#: src/pages/interests/membership.tsx
msgid "Edit my note"
msgstr "Edit my note"

#: src/pages/members/details/member-sidebar.tsx
msgid "Edit my profile"
msgstr "Edit my profile"

#: src/pages/events/edit/edit-event-page.tsx
msgid "Edit the event"
msgstr "Edit the event"

#: src/pages/information/edit/edit-information-page.tsx
msgid "Edit the information"
msgstr "Edit the information"

#: src/pages/requests/edit/edit-request-page.tsx
msgid "Edit the request"
msgstr "Edit the request"

#: src/pages/authentication/authentication.tsx
#: src/pages/profile/contact-section.tsx
msgid "Email address"
msgstr "Email address"

#: src/pages/help/help-page.tsx
#: src/pages/members/details/member-sidebar.tsx
msgid "Email address copied"
msgstr "Email address copied"

#: src/pages/profile/contact-section.tsx
msgid "Enter a phone number such as 06 12 34 56 78"
msgstr "Enter a phone number such as 06 12 34 56 78"

#: src/pages/authentication/authentication.tsx
msgid "Enter a valid email address, for example my@email.com."
msgstr "Enter a valid email address, for example my@email.com."

#: src/pages/authentication/authentication.tsx
msgid "Enter the 6 digits of the code received by email."
msgstr "Enter the 6 digits of the code received by email."

#: src/pages/events/event-form.tsx
msgid "Enter the address of the event"
msgstr "Enter the address of the event"

#: src/pages/authentication/authentication.tsx
msgid "Enter the email address of your LETS account to access the app."
msgstr "Enter the email address of your LETS account to access the app."

#: src/pages/authentication/authentication.tsx
msgid "Enter the sign-in code received by email."
msgstr "Enter the sign-in code received by email."

#: src/pages/events/details/event-page.tsx
msgid "Event"
msgstr "Event"

#: src/pages/home/feed.tsx
msgctxt "feed item"
msgid "Event"
msgstr "Event"

#: src/pages/events/create/create-event-page.tsx
msgid "Event created"
msgstr "Event created"

#: src/pages/events/edit/edit-event-page.tsx
msgid "Event edited"
msgstr "Event edited"

#: src/pages/events/event-not-found.tsx
msgid "Event not found"
msgstr "Event not found"

#: src/app/routes.ts
#: src/pages/events/create/create-event-page.tsx
#: src/pages/events/details/event-page.tsx
#: src/pages/events/list/events-page.tsx
msgid "Events"
msgstr "Events"

#: src/pages/home/feed.tsx
msgctxt "feed filter"
msgid "Events"
msgstr "Events"

#: src/pages/members/details/activity-tab.tsx
#: src/pages/members/details/overview-tab.tsx
msgid "Events attended"
msgstr "Events attended"

#: src/pages/members/details/activity-tab.tsx
#: src/pages/members/details/overview-tab.tsx
msgid "Events organized"
msgstr "Events organized"

#: src/components/transaction-dialog.tsx
msgid "Exchange"
msgstr "Exchange"

#: src/components/transaction-dialog.tsx
msgid "Exchange {units}"
msgstr "Exchange {units}"

#: src/pages/home/home-page.tsx
#: src/pages/members/details/member-sidebar.tsx
#: src/pages/requests/details/request-page.tsx
msgid "Exchange <0/>"
msgstr "Exchange <0/>"

#: src/components/transaction-item.tsx
msgid "Exchange accepted"
msgstr "Exchange accepted"

#: src/components/transaction-item.tsx
msgid "Exchange declined"
msgstr "Exchange declined"

#: src/components/transaction-dialog.tsx
msgid "Exchange recorded"
msgstr "Exchange recorded"

#: src/layout/layout.tsx
#: src/pages/members/details/exchanges-tab.tsx
#: src/pages/members/details/member-page.tsx
#: src/pages/members/details/overview-tab.tsx
#: src/pages/navigation.tsx
msgid "Exchanges"
msgstr "Exchanges"

#: src/pages/help/help-page.tsx
msgid "Exchanging {units}"
msgstr "Exchanging {units}"

#: src/pages/events/details/event-page.tsx
#: src/pages/events/event-form.tsx
#: src/pages/events/list/events-list.tsx
msgid "External event"
msgstr "External event"

#: src/pages/home/profile-completion/08-interests-step.tsx
msgid "Find the members who share your passions, and what they can offer."
msgstr "Find the members who share your passions, and what they can offer."

#: src/pages/help/help-page.tsx
msgid "Finding members"
msgstr "Finding members"

#: src/pages/profile/identity-section.tsx
msgid "First name"
msgstr "First name"

#: src/pages/members/list/members-page.tsx
msgctxt "members sort"
msgid "First name"
msgstr "First name"

#: src/pages/home/push-notifications-prompt.tsx
msgid "Follow the activity of the LETS, even when the app is closed."
msgstr "Follow the activity of the LETS, even when the app is closed."

#: src/pages/profile/address-section.tsx
msgid "For example, 12 rue de la Paix, Lyon"
msgstr "For example, 12 rue de la Paix, Lyon"

#: src/components/transaction-dialog.tsx
msgid "For example: Help with moving"
msgstr "For example: Help with moving"

#: src/pages/events/details/notify-dialog.tsx
msgid "For example: The meeting point has changed"
msgstr "For example: The meeting point has changed"

#: src/pages/home/feed.tsx
#: src/pages/requests/list/requests-list.tsx
msgid "Fulfilled"
msgstr "Fulfilled"

#: src/pages/home/feedback-card.tsx
msgid "Get help"
msgstr "Get help"

#: src/pages/members/details/exchanges-tab.tsx
#: src/pages/members/details/overview-tab.tsx
msgid "Given"
msgstr "Given"

#: src/pages/help/help-page.tsx
msgid "Good to know"
msgstr "Good to know"

#: src/pages/home/home-page.tsx
msgid "Hello {firstName}"
msgstr "Hello {firstName}"

#: src/app/routes.ts
#: src/pages/help/help-page.tsx
msgid "Help"
msgstr "Help"

#: src/pages/help/help-page.tsx
msgid "Helping a member"
msgstr "Helping a member"

#: src/pages/profile/profile-section.tsx
msgid "Hidden from other members"
msgstr "Hidden from other members"

#: src/pages/members/details/exchanges-tab.tsx
msgid "History"
msgstr "History"

#: src/app/routes.ts
#: src/pages/home/home-page.tsx
msgid "Home"
msgstr "Home"

#: src/pages/help/help-page.tsx
msgid "How do I contact a member privately?"
msgstr "How do I contact a member privately?"

#: src/pages/help/help-page.tsx
msgid "How do I get notifications on my phone?"
msgstr "How do I get notifications on my phone?"

#: src/pages/home/profile-completion/04-notifications-step.tsx
msgid "How do you want to be notified?"
msgstr "How do you want to be notified?"

#: src/pages/help/help-page.tsx
msgid "How it works"
msgstr "How it works"

#: src/pages/settings/settings-page.tsx
msgid "How you keep up with the activity of the LETS."
msgstr "How you keep up with the activity of the LETS."

#: src/pages/requests/details/request-answer.tsx
msgid "I can help"
msgstr "I can help"

#: src/pages/requests/details/request-answer.tsx
msgid "I can't"
msgstr "I can't"

#: src/pages/events/details/participation.tsx
msgid "I can't come anymore"
msgstr "I can't come anymore"

#: src/pages/events/details/participation.tsx
#: src/pages/events/list/events-filters.tsx
msgid "I'm coming"
msgstr "I'm coming"

#: src/pages/events/details/participation.tsx
msgid "I'm coming after all"
msgstr "I'm coming after all"

#: src/pages/events/details/participation.tsx
msgid "I'm not coming"
msgstr "I'm not coming"

#: src/pages/authentication/authentication.tsx
msgid "If nothing arrives in the next few minutes, check your spam folder or contact us."
msgstr "If nothing arrives in the next few minutes, check your spam folder or contact us."

#: src/pages/authentication/authentication.tsx
msgid "If this address belongs to a member account, an email containing a sign-in code has been sent to <0>{email}</0>."
msgstr "If this address belongs to a member account, an email containing a sign-in code has been sent to <0>{email}</0>."

#: src/pages/members/details/overview-tab.tsx
msgid "In common"
msgstr "In common"

#: src/pages/home/profile-completion/09-install-app-step.tsx
msgid "In Safari, tap the share button, then “Add to Home Screen”."
msgstr "In Safari, tap the share button, then “Add to Home Screen”."

#: src/pages/help/help-page.tsx
msgid "In the <0>settings</0>, choose “On your devices”, then tap “Allow on this device”. Do it on each phone or computer you use."
msgstr "In the <0>settings</0>, choose “On your devices”, then tap “Allow on this device”. Do it on each phone or computer you use."

#: src/pages/home/profile-completion/09-install-app-step.tsx
msgid "In the menu of your browser, choose “Install the app” or “Add to Home Screen”."
msgstr "In the menu of your browser, choose “Install the app” or “Add to Home Screen”."

#: src/pages/interests/interests-page.tsx
#: src/pages/interests/membership.tsx
msgid "In your interests"
msgstr "In your interests"

#: src/app/routes.ts
#: src/pages/information/create/create-information-page.tsx
#: src/pages/information/details/information-details-page.tsx
#: src/pages/information/list/information-page.tsx
#: src/pages/members/details/activity-tab.tsx
msgid "Information"
msgstr "Information"

#: src/pages/home/feed.tsx
msgctxt "feed filter"
msgid "Information"
msgstr "Information"

#: src/pages/home/feed.tsx
msgctxt "feed item"
msgid "Information"
msgstr "Information"

#: src/pages/information/edit/edit-information-page.tsx
msgid "Information edited"
msgstr "Information edited"

#: src/pages/information/information-not-found.tsx
msgid "Information not found"
msgstr "Information not found"

#: src/pages/information/create/create-information-page.tsx
msgid "Information published"
msgstr "Information published"

#: src/pages/home/profile-completion/09-install-app-step.tsx
msgid "Install"
msgstr "Install"

#: src/pages/home/profile-completion/09-install-app-step.tsx
msgid "Install the app on your phone"
msgstr "Install the app on your phone"

#: src/pages/interests/interest-page.tsx
msgid "Interest"
msgstr "Interest"

#: src/pages/interests/interest-page.tsx
msgid "Interest not found"
msgstr "Interest not found"

#: src/app/routes.ts
#: src/pages/interests/interest-page.tsx
#: src/pages/interests/interests-page.tsx
#: src/pages/members/details/overview-tab.tsx
msgid "Interests"
msgstr "Interests"

#: src/pages/home/profile-completion/07-bio-step.tsx
msgid "Introduce yourself"
msgstr "Introduce yourself"

#: src/pages/events/create/create-event-page.tsx
msgid "Invite members: they'll be notified and can tell whether they're coming."
msgstr "Invite members: they'll be notified and can tell whether they're coming."

#: src/pages/home/profile-completion/01-name-step.tsx
msgid "Is your name correct?"
msgstr "Is your name correct?"

#: src/pages/home/profile-completion/06-avatar-step.tsx
msgid "It helps the other members recognize you."
msgstr "It helps the other members recognize you."

#: src/pages/error-page.tsx
msgid "It'll be back on {date}."
msgstr "It'll be back on {date}."

#: src/pages/error-page.tsx
msgid "It'll be back soon."
msgstr "It'll be back soon."

#: src/components/rich-text-toolbar.tsx
msgid "Italic"
msgstr "Italic"

#: src/pages/information/details/information-details-page.tsx
msgid "Keep it up to date for the members who read it."
msgstr "Keep it up to date for the members who read it."

#: src/pages/events/details/organizer-actions.tsx
msgid "Keep it up to date, and notify the members of what they need to know."
msgstr "Keep it up to date, and notify the members of what they need to know."

#: src/pages/help/help-page.tsx
msgid "Keeping informed"
msgstr "Keeping informed"

#: src/pages/settings/settings-page.tsx
msgid "Language"
msgstr "Language"

#: src/pages/profile/identity-section.tsx
msgid "Last name"
msgstr "Last name"

#: src/pages/members/list/members-page.tsx
msgctxt "members sort"
msgid "Last name"
msgstr "Last name"

#: src/pages/home/profile-completion/10-help-step.tsx
msgid "Learn how the app works"
msgstr "Learn how the app works"

#: src/pages/events/event-form.tsx
msgid "Leave it empty if the date isn't set yet"
msgstr "Leave it empty if the date isn't set yet"

#: src/pages/events/event-form.tsx
msgid "Leave it empty if the location isn't decided yet"
msgstr "Leave it empty if the location isn't decided yet"

#: src/pages/members/details/member-sidebar.tsx
msgid "less than a month"
msgstr "less than a month"

#: src/pages/settings/settings-page.tsx
msgid "Light"
msgstr "Light"

#: src/components/rich-text-toolbar.tsx
msgid "Link"
msgstr "Link"

#: src/components/rich-text-toolbar.tsx
msgid "Link address"
msgstr "Link address"

#: src/pages/events/event-form.tsx
msgid "Location"
msgstr "Location"

#: src/pages/events/event-form.tsx
msgid "Location (optional)"
msgstr "Location (optional)"

#: src/pages/events/details/event-page.tsx
msgid "Location to be decided"
msgstr "Location to be decided"

#: src/layout/layout.tsx
msgid "Main navigation"
msgstr "Main navigation"

#: src/pages/events/event-form.tsx
#: src/pages/profile/address-section.tsx
msgid "Manual entry"
msgstr "Manual entry"

#: src/pages/members/list/members-page.tsx
msgid "Map"
msgstr "Map"

#: src/components/transaction-dialog.tsx
#: src/pages/members/details/member-page.tsx
msgid "Member"
msgstr "Member"

#: src/pages/members/details/member-sidebar.tsx
msgid "Member #{number}"
msgstr "Member #{number}"

#: src/pages/members/details/member-not-found.tsx
msgid "Member not found"
msgstr "Member not found"

#: src/pages/profile/profile-page.tsx
msgid "Member number"
msgstr "Member number"

#: src/pages/members/details/member-page.tsx
msgid "Member sections"
msgstr "Member sections"

#: src/pages/profile/profile-page.tsx
msgid "Member since"
msgstr "Member since"

#: src/pages/members/details/member-sidebar.tsx
msgid "Member since {since} ({duration})"
msgstr "Member since {since} ({duration})"

#: src/app/routes.ts
#: src/components/transaction-dialog.tsx
#: src/pages/interests/interest-page.tsx
#: src/pages/members/details/member-page.tsx
#: src/pages/members/list/members-page.tsx
#: src/pages/members/map/members-map-page.tsx
msgid "Members"
msgstr "Members"

#: src/pages/members/map/members-map-page.tsx
msgid "Members map"
msgstr "Members map"

#: src/pages/requests/details/requester-actions.tsx
msgid "Members will no longer be able to answer it. Those who offered help or commented will be notified."
msgstr "Members will no longer be able to answer it. Those who offered help or commented will be notified."

#: src/pages/home/feed.tsx
msgid "Members' requests, events and information appear here."
msgstr "Members' requests, events and information appear here."

#: src/pages/profile/profile-page.tsx
msgid "Membership"
msgstr "Membership"

#: src/pages/events/details/notify-dialog.tsx
#: src/pages/events/event-form.tsx
#: src/pages/information/information-form.tsx
#: src/pages/requests/request-form.tsx
msgid "Message"
msgstr "Message"

#: src/layout/layout.tsx
#: src/pages/navigation.tsx
msgid "More"
msgstr "More"

#: src/layout/layout.tsx
#: src/pages/navigation.tsx
msgid "My account"
msgstr "My account"

#: src/pages/events/list/events-filters.tsx
msgid "My events"
msgstr "My events"

#: src/pages/information/list/information-filters.tsx
msgid "My information"
msgstr "My information"

#: src/pages/interests/interests-page.tsx
msgid "My interests"
msgstr "My interests"

#: src/pages/requests/list/requests-filters.tsx
msgid "My requests"
msgstr "My requests"

#: src/pages/authentication/authentication.tsx
msgid "my@email.com"
msgstr "my@email.com"

#: src/pages/profile/identity-section.tsx
msgid "Name and photo"
msgstr "Name and photo"

#: src/pages/help/help-page.tsx
msgid "Need help?"
msgstr "Need help?"

#: src/pages/members/list/members-list.tsx
msgctxt "member"
msgid "New"
msgstr "New"

#: src/pages/events/list/events-page.tsx
msgid "New event"
msgstr "New event"

#: src/pages/information/list/information-page.tsx
msgid "New information"
msgstr "New information"

#: src/pages/home/home-page.tsx
#: src/pages/requests/list/requests-page.tsx
msgid "New request"
msgstr "New request"

#: src/pages/members/list/members-page.tsx
msgctxt "members sort"
msgid "Newest"
msgstr "Newest"

#: src/components/transaction-dialog.tsx
#: src/pages/home/profile-completion/03-contact-visibility-step.tsx
#: src/pages/home/profile-completion/04-notifications-step.tsx
msgid "Next"
msgstr "Next"

#: src/pages/home/committee-meeting-card.tsx
msgid "Next committee meeting"
msgstr "Next committee meeting"

#: src/pages/members/details/activity-tab.tsx
msgid "No activity yet"
msgstr "No activity yet"

#: src/pages/members/details/overview-tab.tsx
msgid "No activity yet."
msgstr "No activity yet."

#: src/components/address-search.tsx
msgid "No address found. Check what you typed, or enter the address manually."
msgstr "No address found. Check what you typed, or enter the address manually."

#: src/pages/home/open-requests-card.tsx
msgid "No answers yet"
msgstr "No answers yet"

#: src/pages/members/details/exchanges-tab.tsx
msgid "No declined exchanges"
msgstr "No declined exchanges"

#: src/pages/documents/documents-list.tsx
msgid "No documents"
msgstr "No documents"

#: src/pages/events/list/events-list.tsx
msgid "No event matches these filters"
msgstr "No event matches these filters"

#: src/pages/members/details/exchanges-tab.tsx
msgid "No exchanges with {name} yet"
msgstr "No exchanges with {name} yet"

#: src/pages/members/details/exchanges-tab.tsx
#: src/pages/members/details/overview-tab.tsx
msgid "No exchanges yet"
msgstr "No exchanges yet"

#: src/pages/information/list/information-list.tsx
msgid "No information"
msgstr "No information"

#: src/pages/information/list/information-list.tsx
msgid "No information matches these filters"
msgstr "No information matches these filters"

#: src/pages/interests/interests-page.tsx
msgid "No interests yet"
msgstr "No interests yet"

#: src/pages/interests/membership.tsx
msgid "No longer interested"
msgstr "No longer interested"

#: src/pages/members/list/members-list.tsx
msgid "No member matches these filters"
msgstr "No member matches these filters"

#: src/components/transaction-dialog.tsx
msgid "No member matches this search"
msgstr "No member matches this search"

#: src/pages/members/list/members-list.tsx
msgid "No members"
msgstr "No members"

#: src/pages/interests/interests-page.tsx
msgid "No members yet"
msgstr "No members yet"

#: src/pages/requests/details/request-answers.tsx
msgid "No one answered."
msgstr "No one answered."

#: src/pages/requests/details/request-answers.tsx
msgid "No one has answered yet."
msgstr "No one has answered yet."

#: src/pages/interests/interest-page.tsx
msgid "No one has chosen this interest yet."
msgstr "No one has chosen this interest yet."

#: src/pages/events/details/participants.tsx
msgid "No one has said they're coming yet."
msgstr "No one has said they're coming yet."

#: src/pages/home/profile-completion/02-contact-info-step.tsx
#: src/pages/profile/contact-section.tsx
msgid "No phone number"
msgstr "No phone number"

#: src/pages/home/feed.tsx
msgid "No publication matches these filters"
msgstr "No publication matches these filters"

#: src/pages/requests/list/requests-list.tsx
msgid "No request matches these filters"
msgstr "No request matches these filters"

#: src/pages/requests/list/requests-list.tsx
msgid "No requests"
msgstr "No requests"

#: src/pages/events/list/events-list.tsx
msgid "No upcoming events"
msgstr "No upcoming events"

#: src/pages/interests/membership.tsx
msgid "Note (optional)"
msgstr "Note (optional)"

#: src/pages/help/help-page.tsx
msgid "Nothing happens? <0>Write to us</0> from your usual email."
msgstr "Nothing happens? <0>Write to us</0> from your usual email."

#: src/pages/home/feed.tsx
msgid "Nothing published yet"
msgstr "Nothing published yet"

#: src/pages/events/details/notify-dialog.tsx
msgid "Notification sent"
msgstr "Notification sent"

#: src/pages/settings/settings-page.tsx
msgid "Notifications"
msgstr "Notifications"

#: src/pages/settings/settings-page.tsx
msgid "Notifications appear on the devices where you allowed them, even when the app is closed."
msgstr "Notifications appear on the devices where you allowed them, even when the app is closed."

#: src/pages/home/profile-completion/04-notifications-step.tsx
#: src/pages/settings/settings-page.tsx
msgid "Notifications are blocked on this device. To receive them, allow them in the browser settings."
msgstr "Notifications are blocked on this device. To receive them, allow them in the browser settings."

#: src/pages/home/push-notifications-prompt.tsx
msgid "Notifications are blocked on this device. You can allow them in the browser settings."
msgstr "Notifications are blocked on this device. You can allow them in the browser settings."

#: src/pages/settings/settings-page.tsx
msgid "Notifications are sent to your email address."
msgstr "Notifications are sent to your email address."

#: src/app/push-notifications.ts
#: src/pages/home/profile-completion/04-notifications-step.tsx
#: src/pages/home/push-notifications-prompt.tsx
#: src/pages/settings/settings-page.tsx
msgid "Notifications couldn't be enabled on this device. Try again in a few moments."
msgstr "Notifications couldn't be enabled on this device. Try again in a few moments."

#: src/pages/events/details/notify-dialog.tsx
msgid "Notify members"
msgstr "Notify members"

#: src/components/address-form-dialog.tsx
#: src/pages/profile/address-section.tsx
msgid "Number and street"
msgstr "Number and street"

#: src/components/rich-text-toolbar.tsx
msgid "Numbered list"
msgstr "Numbered list"

#: src/pages/members/details/activity-item.tsx
msgid "Offered to help on {link}"
msgstr "Offered to help on {link}"

#: src/pages/members/details/activity-tab.tsx
#: src/pages/members/details/overview-tab.tsx
msgid "Offers to help"
msgstr "Offers to help"

#: src/pages/help/help-page.tsx
msgid "On an <0>event</0>, say whether you're coming, so that the organizer knows who to expect. You can change your mind until the event."
msgstr "On an <0>event</0>, say whether you're coming, so that the organizer knows who to expect. You can change your mind until the event."

#: src/pages/help/help-page.tsx
msgid "On an iPhone, first install the app: in Safari, tap the share button, then “Add to Home Screen”, and open the app from there."
msgstr "On an iPhone, first install the app: in Safari, tap the share button, then “Add to Home Screen”, and open the app from there."

#: src/pages/home/profile-completion/04-notifications-step.tsx
msgid "On an iPhone, the app must be installed to receive notifications."
msgstr "On an iPhone, the app must be installed to receive notifications."

#: src/pages/home/profile-completion/04-notifications-step.tsx
#: src/pages/settings/settings-page.tsx
msgid "On your devices"
msgstr "On your devices"

#: src/pages/help/help-page.tsx
msgid "Once a service is done, the member who received it pays the other one. Tap “Exchange {units}” on the home page or on the member's profile."
msgstr "Once a service is done, the member who received it pays the other one. Tap “Exchange {units}” on the home page or on the member's profile."

#: src/pages/information/edit/edit-information-page.tsx
msgid "Only the author can edit this information."
msgstr "Only the author can edit this information."

#: src/pages/requests/edit/edit-request-page.tsx
msgid "Only the author can edit this request, while it's open."
msgstr "Only the author can edit this request, while it's open."

#: src/pages/help/help-page.tsx
msgid "Only the members of the LETS, and only if you allow it on your <0>profile</0>."
msgstr "Only the members of the LETS, and only if you allow it on your <0>profile</0>."

#: src/pages/events/edit/edit-event-page.tsx
msgid "Only the organizer can edit this event."
msgstr "Only the organizer can edit this event."

#: src/pages/requests/list/requests-filters.tsx
msgctxt "requests filter"
msgid "Open"
msgstr "Open"

#: src/pages/help/help-page.tsx
msgid "Open a request and answer “I can help”. The member who asked is notified, and you get in touch to arrange the details."
msgstr "Open a request and answer “I can help”. The member who asked is notified, and you get in touch to arrange the details."

#: src/pages/home/profile-completion/09-install-app-step.tsx
msgid "Open it from your home screen, like any other app."
msgstr "Open it from your home screen, like any other app."

#: src/pages/members/details/activity-item.tsx
msgid "Organized {link}"
msgstr "Organized {link}"

#: src/pages/events/details/organizer.tsx
msgid "Organized by"
msgstr "Organized by"

#: src/pages/events/event-form.tsx
msgid "Organized by the LETS"
msgstr "Organized by the LETS"

#: src/pages/events/event-form.tsx
msgid "Organizer"
msgstr "Organizer"

#: src/pages/members/details/activity-item.tsx
msgid "Organizes {link}"
msgstr "Organizes {link}"

#: src/pages/members/details/member-page.tsx
msgid "Overview"
msgstr "Overview"

#: src/pages/error-page.tsx
msgid "Page not found"
msgstr "Page not found"

#: src/pages/members/details/exchanges-tab.tsx
msgid "Partners"
msgstr "Partners"

#: src/pages/events/list/events-filters.tsx
msgctxt "events filter"
msgid "Past"
msgstr "Past"

#: src/pages/events/details/event-page.tsx
msgid "Past event"
msgstr "Past event"

#: src/pages/members/details/exchanges-tab.tsx
msgid "Pending"
msgstr "Pending"

#: src/pages/home/pending-transactions-card.tsx
msgid "Pending exchanges"
msgstr "Pending exchanges"

#: src/pages/profile/contact-section.tsx
msgid "Phone number"
msgstr "Phone number"

#: src/pages/members/details/member-sidebar.tsx
msgid "Phone number copied"
msgstr "Phone number copied"

#: src/pages/events/event-form.tsx
#: src/pages/information/information-form.tsx
#: src/pages/requests/request-form.tsx
msgid "Photos or documents, up to 10 MB per file"
msgstr "Photos or documents, up to 10 MB per file"

#: src/pages/help/help-page.tsx
msgid "Post a <0>request</0> describing what you need. The members who can help tell you so, and you contact them to arrange the details. Close the request once you've been helped."
msgstr "Post a <0>request</0> describing what you need. The members who can help tell you so, and you contact them to arrange the details. Close the request once you've been helped."

#: src/pages/members/details/activity-tab.tsx
#: src/pages/requests/create/create-request-page.tsx
#: src/pages/requests/list/requests-list.tsx
msgid "Post a request"
msgstr "Post a request"

#: src/pages/requests/create/create-request-page.tsx
msgid "Post the request"
msgstr "Post the request"

#: src/components/address-form-dialog.tsx
#: src/pages/profile/address-section.tsx
msgid "Postal code"
msgstr "Postal code"

#: src/pages/members/details/activity-item.tsx
msgid "Posted the information {link}"
msgstr "Posted the information {link}"

#: src/pages/members/details/activity-item.tsx
msgid "Posted the request {link}"
msgstr "Posted the request {link}"

#: src/app/routes.ts
#: src/pages/profile/profile-page.tsx
msgid "Profile"
msgstr "Profile"

#: src/pages/profile/profile-section.tsx
msgid "Profile updated"
msgstr "Profile updated"

#: src/pages/information/create/create-information-page.tsx
#: src/pages/information/list/information-list.tsx
msgid "Publish information"
msgstr "Publish information"

#: src/pages/information/create/create-information-page.tsx
msgid "Publish the information"
msgstr "Publish the information"

#: src/pages/information/details/information-details-page.tsx
msgid "Published by"
msgstr "Published by"

#: src/pages/home/profile-completion/10-help-step.tsx
msgid "Read the help"
msgstr "Read the help"

#: src/pages/home/push-notifications-prompt.tsx
msgid "Receive notifications on this device?"
msgstr "Receive notifications on this device?"

#: src/pages/members/details/exchanges-tab.tsx
#: src/pages/members/details/overview-tab.tsx
msgid "Received"
msgstr "Received"

#: src/pages/members/details/activity-item.tsx
msgid "Received {amount} from {payer}"
msgstr "Received {amount} from {payer}"

#: src/pages/events/details/notify-dialog.tsx
msgid "Recipients"
msgstr "Recipients"

#: src/components/attachments.tsx
msgid "Remove {name}"
msgstr "Remove {name}"

#: src/components/rich-text-toolbar.tsx
msgid "Remove link"
msgstr "Remove link"

#: src/pages/profile/address-section.tsx
msgid "Remove my address"
msgstr "Remove my address"

#: src/pages/events/event-form.tsx
msgid "Remove the location"
msgstr "Remove the location"

#: src/pages/profile/identity-section.tsx
msgid "Remove the photo"
msgstr "Remove the photo"

#: src/pages/help/help-page.tsx
#: src/pages/home/feedback-card.tsx
msgid "Report a bug"
msgstr "Report a bug"

#: src/pages/requests/details/request-page.tsx
msgid "Request"
msgstr "Request"

#: src/pages/home/feed.tsx
msgctxt "feed item"
msgid "Request"
msgstr "Request"

#: src/components/transaction-dialog.tsx
msgid "Request {units}"
msgstr "Request {units}"

#: src/components/transaction-dialog.tsx
msgid "Request {units} from {name}"
msgstr "Request {units} from {name}"

#: src/components/transaction-dialog.tsx
msgid "Request <0/>"
msgstr "Request <0/>"

#: src/components/transaction-dialog.tsx
msgctxt "amount"
msgid "Request <0/>"
msgstr "Request <0/>"

#: src/pages/requests/details/requester-actions.tsx
msgid "Request canceled"
msgstr "Request canceled"

#: src/pages/requests/details/requester-actions.tsx
msgid "Request closed"
msgstr "Request closed"

#: src/pages/requests/edit/edit-request-page.tsx
msgid "Request edited"
msgstr "Request edited"

#: src/pages/requests/request-not-found.tsx
msgid "Request not found"
msgstr "Request not found"

#: src/pages/requests/create/create-request-page.tsx
msgid "Request posted"
msgstr "Request posted"

#: src/components/transaction-dialog.tsx
msgid "Request sent to {name}"
msgstr "Request sent to {name}"

#: src/pages/requests/details/requester.tsx
msgid "Requested by"
msgstr "Requested by"

#: src/app/routes.ts
#: src/pages/members/details/activity-tab.tsx
#: src/pages/members/details/overview-tab.tsx
#: src/pages/requests/create/create-request-page.tsx
#: src/pages/requests/details/request-page.tsx
#: src/pages/requests/list/requests-page.tsx
msgid "Requests"
msgstr "Requests"

#: src/pages/home/feed.tsx
msgctxt "feed filter"
msgid "Requests"
msgstr "Requests"

#: src/pages/settings/settings-page.tsx
msgid "Reset the demo data"
msgstr "Reset the demo data"

#: src/pages/settings/settings-page.tsx
msgid "Resetting brings back the demo data as it was on your first visit."
msgstr "Resetting brings back the demo data as it was on your first visit."

#: src/components/api-result.tsx
#: src/pages/error-page.tsx
msgid "Retry"
msgstr "Retry"

#: src/pages/settings/settings-page.tsx
msgid "Same as the device"
msgstr "Same as the device"

#: src/pages/events/event-form.tsx
#: src/pages/interests/membership.tsx
#: src/pages/profile/profile-section.tsx
msgid "Save"
msgstr "Save"

#: src/pages/events/edit/edit-event-page.tsx
#: src/pages/information/edit/edit-information-page.tsx
#: src/pages/requests/edit/edit-request-page.tsx
msgid "Save the changes"
msgstr "Save the changes"

#: src/pages/events/list/events-filters.tsx
#: src/pages/home/feed.tsx
#: src/pages/information/list/information-filters.tsx
#: src/pages/requests/list/requests-filters.tsx
msgid "Search"
msgstr "Search"

#: src/pages/events/list/events-filters.tsx
msgid "Search events"
msgstr "Search events"

#: src/components/transaction-dialog.tsx
msgid "Search for a member"
msgstr "Search for a member"

#: src/pages/profile/address-section.tsx
msgid "Search for an address"
msgstr "Search for an address"

#: src/pages/information/list/information-filters.tsx
msgid "Search information"
msgstr "Search information"

#: src/pages/members/list/members-page.tsx
msgid "Search members"
msgstr "Search members"

#: src/pages/home/feed.tsx
msgid "Search publications"
msgstr "Search publications"

#: src/pages/requests/list/requests-filters.tsx
msgid "Search requests"
msgstr "Search requests"

#: src/pages/members/details/overview-tab.tsx
msgid "See activity"
msgstr "See activity"

#: src/pages/events/event-not-found.tsx
#: src/pages/home/upcoming-events-card.tsx
msgid "See all events"
msgstr "See all events"

#: src/pages/information/information-not-found.tsx
msgctxt "information list"
msgid "See all information"
msgstr "See all information"

#: src/pages/interests/interest-page.tsx
#: src/pages/interests/interests-page.tsx
msgid "See all interests"
msgstr "See all interests"

#: src/pages/members/details/former-member.tsx
#: src/pages/members/details/member-not-found.tsx
msgid "See all members"
msgstr "See all members"

#: src/pages/requests/request-not-found.tsx
msgid "See all requests"
msgstr "See all requests"

#: src/pages/members/details/overview-tab.tsx
msgid "See exchanges"
msgstr "See exchanges"

#: src/pages/members/details/overview-tab.tsx
msgid "See more"
msgstr "See more"

#: src/pages/profile/profile-page.tsx
msgid "See my public profile"
msgstr "See my public profile"

#: src/pages/events/edit/edit-event-page.tsx
msgid "See the event"
msgstr "See the event"

#: src/pages/information/edit/edit-information-page.tsx
msgid "See the information"
msgstr "See the information"

#: src/pages/home/profile-completion/08-interests-step.tsx
msgid "See the interests"
msgstr "See the interests"

#: src/pages/requests/edit/edit-request-page.tsx
msgid "See the request"
msgstr "See the request"

#: src/hooks/use-zod-resolver.ts
msgid "Select an option"
msgstr "Select an option"

#: src/components/comments-section.tsx
#: src/pages/events/details/notify-dialog.tsx
msgid "Send"
msgstr "Send"

#: src/components/transaction-dialog.tsx
msgid "Send {units}"
msgstr "Send {units}"

#: src/components/transaction-dialog.tsx
msgid "Send {units} to {name}"
msgstr "Send {units} to {name}"

#: src/components/transaction-dialog.tsx
msgid "Send <0/>"
msgstr "Send <0/>"

#: src/components/transaction-dialog.tsx
msgctxt "amount"
msgid "Send <0/>"
msgstr "Send <0/>"

#: src/pages/members/details/activity-item.tsx
msgid "Sent {amount} to {recipient}"
msgstr "Sent {amount} to {recipient}"

#: src/app/routes.ts
#: src/pages/settings/settings-page.tsx
msgid "Settings"
msgstr "Settings"

#: src/pages/information/create/create-information-page.tsx
msgid "Share news with members: they'll be notified and can comment."
msgstr "Share news with members: they'll be notified and can comment."

#: src/pages/home/profile-completion/08-interests-step.tsx
msgid "Share your interests"
msgstr "Share your interests"

#: src/pages/events/details/organizer.tsx
msgid "Shared by"
msgstr "Shared by"

#: src/pages/members/details/exchanges-tab.tsx
msgid "Show all exchanges"
msgstr "Show all exchanges"

#: src/pages/members/details/activity-tab.tsx
msgid "Show comments"
msgstr "Show comments"

#: src/pages/members/details/exchanges-tab.tsx
msgid "Show completed exchanges"
msgstr "Show completed exchanges"

#: src/pages/error-page.tsx
msgid "Show details"
msgstr "Show details"

#: src/components/pagination.tsx
msgid "Show more"
msgstr "Show more"

#: src/pages/home/profile-completion/03-contact-visibility-step.tsx
msgid "Show my email address on my member page"
msgstr "Show my email address on my member page"

#: src/pages/profile/contact-section.tsx
msgid "Show my email address to other members"
msgstr "Show my email address to other members"

#: src/pages/home/profile-completion/03-contact-visibility-step.tsx
msgid "Show my phone number on my member page"
msgstr "Show my phone number on my member page"

#: src/pages/profile/contact-section.tsx
msgid "Show my phone number to other members"
msgstr "Show my phone number to other members"

#: src/pages/members/details/member-sidebar.tsx
msgid "Show on the members map"
msgstr "Show on the members map"

#: src/pages/members/details/member-sidebar.tsx
msgid "Show the map"
msgstr "Show the map"

#. placeholder {0}: items.length
#: src/pages/members/details/activity-tab.tsx
msgid "Showing {0} of {total} activities"
msgstr "Showing {0} of {total} activities"

#. placeholder {0}: events.length
#: src/pages/events/list/events-list.tsx
msgid "Showing {0} of {total} events"
msgstr "Showing {0} of {total} events"

#. placeholder {0}: transactions.length
#: src/pages/members/details/exchanges-tab.tsx
msgid "Showing {0} of {total} exchanges"
msgstr "Showing {0} of {total} exchanges"

#. placeholder {0}: transactions.length
#: src/pages/members/details/exchanges-tab.tsx
msgid "Showing {0} of {total} pending exchanges"
msgstr "Showing {0} of {total} pending exchanges"

#. placeholder {0}: items.length
#: src/pages/information/list/information-list.tsx
msgid "Showing {0} of {total} pieces of information"
msgstr "Showing {0} of {total} pieces of information"

#. placeholder {0}: items.length
#: src/pages/home/feed.tsx
msgid "Showing {0} of {total} publications"
msgstr "Showing {0} of {total} publications"

#. placeholder {0}: requests.length
#: src/pages/requests/list/requests-list.tsx
msgid "Showing {0} of {total} requests"
msgstr "Showing {0} of {total} requests"

#: src/pages/authentication/authentication.tsx
msgid "Sign in"
msgstr "Sign in"

#: src/layout/layout.tsx
#: src/pages/navigation.tsx
msgid "Sign out"
msgstr "Sign out"

#: src/pages/authentication/authentication.tsx
msgid "Sign-in code"
msgstr "Sign-in code"

#: src/pages/authentication/authentication.tsx
msgid "Sign-in failed. Try again in a few moments."
msgstr "Sign-in failed. Try again in a few moments."

#: src/pages/home/profile-completion/05-address-step.tsx
#: src/pages/home/profile-completion/06-avatar-step.tsx
#: src/pages/home/profile-completion/07-bio-step.tsx
#: src/pages/home/profile-completion/08-interests-step.tsx
#: src/pages/home/profile-completion/09-install-app-step.tsx
#: src/pages/home/profile-completion/10-help-step.tsx
msgid "Skip"
msgstr "Skip"

#: src/pages/help/help-page.tsx
#: src/pages/home/feedback-card.tsx
msgid "Something doesn't work as expected"
msgstr "Something doesn't work as expected"

#: src/pages/members/list/members-page.tsx
msgid "Sort"
msgstr "Sort"

#: src/components/transaction-dialog.tsx
msgid "Step {stepNumber} of {stepCount}"
msgstr "Step {stepNumber} of {stepCount}"

#: src/components/transaction-dialog.tsx
msgid "Subject"
msgstr "Subject"

#: src/pages/help/help-page.tsx
#: src/pages/home/feedback-card.tsx
msgid "Suggest an idea"
msgstr "Suggest an idea"

#: src/pages/help/help-page.tsx
msgid "Taking part in events"
msgstr "Taking part in events"

#: src/pages/home/profile-completion/01-name-step.tsx
msgid "That's it"
msgstr "That's it"

#: src/pages/help/help-page.tsx
msgid "The <0>information</0> page gathers the news of the LETS and the members' posts. The useful files, such as the statutes, are in the <1>documents</1>."
msgstr "The <0>information</0> page gathers the news of the LETS and the members' posts. The useful files, such as the statutes, are in the <1>documents</1>."

#: src/pages/help/help-page.tsx
msgid "The <0>members</0> page lists everyone in the LETS, with a map of who lives nearby. The <1>interests</1> show who shares what you like."
msgstr "The <0>members</0> page lists everyone in the LETS, with a map of who lives nearby. The <1>interests</1> show who shares what you like."

#: src/pages/home/profile-completion/04-notifications-step.tsx
msgid "The app needs your permission to receive notifications."
msgstr "The app needs your permission to receive notifications."

#: src/pages/error-page.tsx
msgid "The application is under maintenance"
msgstr "The application is under maintenance"

#: src/pages/members/details/exchanges-tab.tsx
msgid "The declined exchanges will appear here."
msgstr "The declined exchanges will appear here."

#: src/pages/settings/settings-page.tsx
msgid "The demo data couldn't be reset"
msgstr "The demo data couldn't be reset"

#: src/pages/documents/documents-list.tsx
msgid "The documents shared by the committee, such as the statutes and the meeting minutes, appear here."
msgstr "The documents shared by the committee, such as the statutes and the meeting minutes, appear here."

#: src/pages/events/create/create-event-page.tsx
msgid "The event couldn't be created"
msgstr "The event couldn't be created"

#: src/components/transaction-dialog.tsx
msgid "The exchange couldn't be created"
msgstr "The exchange couldn't be created"

#: src/components/transaction-item.tsx
msgid "The exchange couldn't be updated"
msgstr "The exchange couldn't be updated"

#: src/pages/home/profile-completion/10-help-step.tsx
msgid "The help answers the most frequent questions about the LETS and the app."
msgstr "The help answers the most frequent questions about the LETS and the app."

#: src/pages/information/create/create-information-page.tsx
msgid "The information couldn't be published"
msgstr "The information couldn't be published"

#: src/pages/interests/interests-page.tsx
msgid "The interests set up by the LETS will appear here."
msgstr "The interests set up by the LETS will appear here."

#: src/pages/events/event-not-found.tsx
msgid "The link may be wrong, or the event may no longer exist."
msgstr "The link may be wrong, or the event may no longer exist."

#: src/pages/information/information-not-found.tsx
msgid "The link may be wrong, or the information may no longer exist."
msgstr "The link may be wrong, or the information may no longer exist."

#: src/pages/interests/interest-page.tsx
msgid "The link may be wrong, or the interest may no longer exist."
msgstr "The link may be wrong, or the interest may no longer exist."

#: src/pages/error-page.tsx
msgid "The link may be wrong, or the page may no longer exist."
msgstr "The link may be wrong, or the page may no longer exist."

#: src/pages/requests/request-not-found.tsx
msgid "The link may be wrong, or the request may no longer exist."
msgstr "The link may be wrong, or the request may no longer exist."

#: src/pages/members/details/member-not-found.tsx
msgid "The link may be wrong."
msgstr "The link may be wrong."

#: src/pages/members/list/members-list.tsx
msgid "The members of the association appear here once their account is active."
msgstr "The members of the association appear here once their account is active."

#: src/pages/events/edit/edit-event-page.tsx
msgid "The members who are coming or who commented will see the new version."
msgstr "The members who are coming or who commented will see the new version."

#: src/pages/requests/edit/edit-request-page.tsx
msgid "The members who offered help or commented will see the new version."
msgstr "The members who offered help or commented will see the new version."

#: src/pages/help/help-page.tsx
msgid "The members who took part: the author, those who offered their help or are coming, and those who already commented."
msgstr "The members who took part: the author, those who offered their help or are coming, and those who already commented."

#: src/pages/information/edit/edit-information-page.tsx
msgid "The members will see the new version."
msgstr "The members will see the new version."

#: src/pages/events/details/notify-dialog.tsx
msgid "The notification couldn't be sent"
msgstr "The notification couldn't be sent"

#: src/app/push-notifications.ts
msgid "The notification settings couldn't be saved"
msgstr "The notification settings couldn't be saved"

#: src/pages/events/details/participation.tsx
msgid "The organizer will know who to expect."
msgstr "The organizer will know who to expect."

#: src/pages/events/details/notify-dialog.tsx
msgid "The other members"
msgstr "The other members"

#: src/pages/interests/membership.tsx
msgid "The other members will see you in this interest, with your note."
msgstr "The other members will see you in this interest, with your note."

#: src/pages/events/details/notify-dialog.tsx
msgid "The participants ({participantsCount})"
msgstr "The participants ({participantsCount})"

#: src/pages/home/profile-completion/06-avatar-step.tsx
#: src/pages/profile/identity-section.tsx
msgid "The photo couldn't be sent. Try again in a few moments."
msgstr "The photo couldn't be sent. Try again in a few moments."

#: src/pages/home/profile-completion/06-avatar-step.tsx
#: src/pages/profile/identity-section.tsx
msgid "The photo must be an image"
msgstr "The photo must be an image"

#: src/pages/home/profile-completion/06-avatar-step.tsx
#: src/pages/profile/identity-section.tsx
msgid "The photo must be at most 10 MB"
msgstr "The photo must be at most 10 MB"

#: src/pages/events/event-form.tsx
msgid "The program, what to bring, how to get there"
msgstr "The program, what to bring, how to get there"

#: src/pages/requests/details/requester-actions.tsx
msgid "The request couldn't be canceled"
msgstr "The request couldn't be canceled"

#: src/pages/requests/details/requester-actions.tsx
msgid "The request couldn't be closed"
msgstr "The request couldn't be closed"

#: src/components/address-search.tsx
msgid "The search isn't available at the moment. Enter the address manually."
msgstr "The search isn't available at the moment. Enter the address manually."

#: src/pages/authentication/authentication.tsx
msgid "The sign-in code couldn't be sent. Try again in a few moments."
msgstr "The sign-in code couldn't be sent. Try again in a few moments."

#: src/pages/help/help-page.tsx
msgid "Their phone number and email address are on their profile, if they chose to show them."
msgstr "Their phone number and email address are on their profile, if they chose to show them."

#: src/pages/members/details/former-member.tsx
msgid "Their profile is no longer available."
msgstr "Their profile is no longer available."

#: src/pages/events/details/notify-dialog.tsx
msgid "They receive it by email or on their devices, depending on their settings."
msgstr "They receive it by email or on their devices, depending on their settings."

#: src/pages/settings/settings-page.tsx
msgid "This browser can't receive notifications. On an iPhone, first add the app to the home screen."
msgstr "This browser can't receive notifications. On an iPhone, first add the app to the home screen."

#: src/pages/authentication/authentication.tsx
msgid "This code has been replaced by a newer one: use the one from the latest email."
msgstr "This code has been replaced by a newer one: use the one from the latest email."

#: src/pages/authentication/authentication.tsx
msgid "This code has expired. Go back to receive a new one."
msgstr "This code has expired. Go back to receive a new one."

#: src/pages/authentication/authentication.tsx
msgid "This code isn't valid. Check that it matches the one in the email."
msgstr "This code isn't valid. Check that it matches the one in the email."

#: src/pages/settings/settings-page.tsx
msgid "This device doesn't receive notifications yet"
msgstr "This device doesn't receive notifications yet"

#: src/pages/home/push-notifications-prompt.tsx
#: src/pages/settings/settings-page.tsx
msgid "This device will receive notifications"
msgstr "This device will receive notifications"

#: src/pages/events/edit/edit-event-page.tsx
msgid "This event can't be edited"
msgstr "This event can't be edited"

#: src/hooks/use-zod-resolver.ts
#: src/pages/profile/address-section.tsx
msgid "This field is required"
msgstr "This field is required"

#: src/hooks/use-zod-resolver.ts
msgid "This field should be a number"
msgstr "This field should be a number"

#: src/hooks/use-zod-resolver.ts
msgid "This field should be a whole number"
msgstr "This field should be a whole number"

#. placeholder {0}: error.minimum
#: src/hooks/use-zod-resolver.ts
msgid "This field should be at least {0}"
msgstr "This field should be at least {0}"

#. placeholder {0}: error.minimum
#: src/hooks/use-zod-resolver.ts
msgid "This field should be at least {0} characters"
msgstr "This field should be at least {0} characters"

#. placeholder {0}: error.maximum
#: src/hooks/use-zod-resolver.ts
msgid "This field should be at most {0}"
msgstr "This field should be at most {0}"

#. placeholder {0}: error.maximum
#: src/hooks/use-zod-resolver.ts
msgid "This field should be at most {0} characters"
msgstr "This field should be at most {0} characters"

#: src/pages/information/edit/edit-information-page.tsx
msgid "This information can't be edited"
msgstr "This information can't be edited"

#: src/pages/interests/membership.tsx
msgid "This interest couldn't be added"
msgstr "This interest couldn't be added"

#: src/pages/interests/membership.tsx
msgid "This interest couldn't be removed"
msgstr "This interest couldn't be removed"

#: src/pages/home/profile-completion/01-name-step.tsx
msgid "This is how the other members see you."
msgstr "This is how the other members see you."

#: src/pages/members/details/former-member.tsx
msgid "This person is no longer a member"
msgstr "This person is no longer a member"

#: src/pages/requests/edit/edit-request-page.tsx
msgid "This request can't be edited"
msgstr "This request can't be edited"

#: src/pages/requests/details/request-status.tsx
msgid "This request is fulfilled"
msgstr "This request is fulfilled"

#: src/pages/requests/details/request-status.tsx
msgid "This request was canceled"
msgstr "This request was canceled"

#: src/components/rich-text-toolbar.tsx
msgid "This URL is invalid"
msgstr "This URL is invalid"

#: src/pages/members/details/activity-tab.tsx
msgid "Timeline"
msgstr "Timeline"

#: src/pages/events/details/notify-dialog.tsx
#: src/pages/events/event-form.tsx
#: src/pages/information/information-form.tsx
#: src/pages/requests/request-form.tsx
msgid "Title"
msgstr "Title"

#: src/pages/profile/contact-section.tsx
msgid "To change it, <0>contact an administrator</0>."
msgstr "To change it, <0>contact an administrator</0>."

#: src/pages/events/list/events-list.tsx
#: src/pages/home/feed.tsx
#: src/pages/information/list/information-list.tsx
#: src/pages/requests/list/requests-list.tsx
msgid "Try other words, or clear filters."
msgstr "Try other words, or clear filters."

#: src/hooks/use-clipboard.tsx
msgid "Unable to copy"
msgstr "Unable to copy"

#: src/pages/members/details/activity-tab.tsx
#: src/pages/members/details/overview-tab.tsx
msgid "Unable to load activity"
msgstr "Unable to load activity"

#: src/components/comments-section.tsx
msgid "Unable to load comments"
msgstr "Unable to load comments"

#: src/pages/documents/documents-list.tsx
msgid "Unable to load documents"
msgstr "Unable to load documents"

#: src/pages/events/list/events-list.tsx
msgid "Unable to load events"
msgstr "Unable to load events"

#: src/pages/members/details/exchanges-tab.tsx
#: src/pages/members/details/overview-tab.tsx
msgid "Unable to load exchanges"
msgstr "Unable to load exchanges"

#: src/pages/information/list/information-list.tsx
msgctxt "information list"
msgid "Unable to load information"
msgstr "Unable to load information"

#: src/pages/interests/interests-page.tsx
msgid "Unable to load interests"
msgstr "Unable to load interests"

#: src/components/transaction-dialog.tsx
#: src/pages/members/list/members-list.tsx
#: src/pages/members/map/members-map-page.tsx
msgid "Unable to load members"
msgstr "Unable to load members"

#: src/components/pagination.tsx
msgid "Unable to load more"
msgstr "Unable to load more"

#: src/pages/members/details/exchanges-tab.tsx
msgid "Unable to load pending exchanges"
msgstr "Unable to load pending exchanges"

#: src/pages/requests/list/requests-list.tsx
msgid "Unable to load requests"
msgstr "Unable to load requests"

#: src/pages/members/details/activity-tab.tsx
#: src/pages/members/details/overview-tab.tsx
msgid "Unable to load the activity summary"
msgstr "Unable to load the activity summary"

#: src/pages/events/details/event-page.tsx
#: src/pages/events/edit/edit-event-page.tsx
msgid "Unable to load the event"
msgstr "Unable to load the event"

#: src/pages/members/details/exchanges-tab.tsx
#: src/pages/members/details/overview-tab.tsx
msgid "Unable to load the exchanges summary"
msgstr "Unable to load the exchanges summary"

#: src/pages/information/details/information-details-page.tsx
#: src/pages/information/edit/edit-information-page.tsx
msgid "Unable to load the information"
msgstr "Unable to load the information"

#: src/pages/interests/interest-page.tsx
msgid "Unable to load the interest"
msgstr "Unable to load the interest"

#: src/pages/home/feed.tsx
msgid "Unable to load the latest news"
msgstr "Unable to load the latest news"

#: src/pages/members/details/member-page.tsx
msgid "Unable to load the member"
msgstr "Unable to load the member"

#: src/pages/requests/details/request-page.tsx
#: src/pages/requests/edit/edit-request-page.tsx
msgid "Unable to load the request"
msgstr "Unable to load the request"

#: src/pages/error-page.tsx
msgid "Unable to reach the server"
msgstr "Unable to reach the server"

#: src/hooks/use-form-api-error.ts
msgid "Unable to reach the server. Check your internet connection."
msgstr "Unable to reach the server. Check your internet connection."

#: src/components/rich-text-toolbar.tsx
msgid "Underline"
msgstr "Underline"

#: src/pages/events/list/events-filters.tsx
msgctxt "events filter"
msgid "Upcoming"
msgstr "Upcoming"

#: src/pages/home/upcoming-events-card.tsx
msgid "Upcoming events"
msgstr "Upcoming events"

#: src/pages/settings/settings-page.tsx
msgid "Version {version}"
msgstr "Version {version}"

#: src/pages/profile/profile-section.tsx
msgid "Visible to other members"
msgstr "Visible to other members"

#: src/components/transaction-item.tsx
msgid "Waiting for {payer} to confirm"
msgstr "Waiting for {payer} to confirm"

#: src/pages/help/help-page.tsx
msgid "We prefer comments so that everyone stays in the loop."
msgstr "We prefer comments so that everyone stays in the loop."

#: src/components/transaction-dialog.tsx
msgid "What do you want to do?"
msgstr "What do you want to do?"

#: src/pages/help/help-page.tsx
msgid "What happened?\n"
"\n"
"\n"
"What did you expect instead?\n"
"\n"
"\n"
"---\n"
"Member #{memberNumber}\n"
"Version {version}\n"
"{userAgent}"
msgstr "What happened?\n"
"\n"
"\n"
"What did you expect instead?\n"
"\n"
"\n"
"---\n"
"Member #{memberNumber}\n"
"Version {version}\n"
"{userAgent}"

#: src/pages/interests/membership.tsx
msgid "What you can share, what you're looking for, your level…"
msgstr "What you can share, what you're looking for, your level…"

#: src/pages/requests/request-form.tsx
msgid "What you need, when, and where"
msgstr "What you need, when, and where"

#: src/pages/home/feed.tsx
msgid "What's new"
msgstr "What's new"

#: src/pages/requests/list/requests-list.tsx
msgid "When a member needs a hand, their request appears here."
msgstr "When a member needs a hand, their request appears here."

#: src/pages/events/list/events-list.tsx
msgid "When a member organizes an event, it appears here."
msgstr "When a member organizes an event, it appears here."

#: src/pages/information/list/information-list.tsx
msgid "When a member shares news with the others, it appears here."
msgstr "When a member shares news with the others, it appears here."

#: src/pages/help/help-page.tsx
msgid "Who can see my phone number and email address?"
msgstr "Who can see my phone number and email address?"

#: src/pages/help/help-page.tsx
msgid "Who is notified when I post a request or an event?"
msgstr "Who is notified when I post a request or an event?"

#: src/pages/help/help-page.tsx
msgid "Who is notified when I write a comment?"
msgstr "Who is notified when I write a comment?"

#: src/pages/home/profile-completion/03-contact-visibility-step.tsx
msgid "Who sees your contact details?"
msgstr "Who sees your contact details?"

#: src/pages/members/details/exchanges-tab.tsx
msgid "With me"
msgstr "With me"

#: src/pages/events/details/participation.tsx
#: src/pages/requests/details/request-answer.tsx
msgid "Withdraw my answer"
msgstr "Withdraw my answer"

#: src/components/comments-section.tsx
msgid "Write a comment"
msgstr "Write a comment"

#: src/pages/home/profile-completion/07-bio-step.tsx
msgid "Write a few words"
msgstr "Write a few words"

#: src/pages/help/help-page.tsx
msgid "Write to us"
msgstr "Write to us"

#: src/pages/help/help-page.tsx
msgid "Yes, but your reply only reaches one person, not the other participants. To keep everyone informed, write a comment in the app instead."
msgstr "Yes, but your reply only reaches one person, not the other participants. To keep everyone informed, write a comment in the app instead."

#: src/pages/help/help-page.tsx
msgid "You can also ask a member to pay you: the exchange then waits until they accept it."
msgstr "You can also ask a member to pay you: the exchange then waits until they accept it."

#: src/pages/events/details/participation.tsx
msgid "You can change your mind until the event."
msgstr "You can change your mind until the event."

#: src/pages/requests/details/request-answer.tsx
msgid "You can help"
msgstr "You can help"

#: src/pages/requests/details/requester-actions.tsx
msgid "You can still send them after closing it."
msgstr "You can still send them after closing it."

#: src/pages/requests/details/request-answer.tsx
msgid "You can't help"
msgstr "You can't help"

#: src/pages/interests/interests-page.tsx
msgid "You haven't chosen any interest yet"
msgstr "You haven't chosen any interest yet"

#: src/pages/members/details/overview-tab.tsx
msgid "You haven't chosen any interest yet. <0>Browse interests</0>"
msgstr "You haven't chosen any interest yet. <0>Browse interests</0>"

#: src/pages/home/profile-completion/05-address-step.tsx
#: src/pages/profile/address-section.tsx
msgid "You haven't entered your address yet."
msgstr "You haven't entered your address yet."

#: src/pages/requests/details/requester-actions.tsx
msgid "You haven't sent any <0/> for this request"
msgstr "You haven't sent any <0/> for this request"

#: src/pages/members/details/overview-tab.tsx
msgid "You haven't written a bio yet. <0>Write my bio</0>"
msgstr "You haven't written a bio yet. <0>Write my bio</0>"

#: src/pages/interests/membership.tsx
msgid "You haven't written a note."
msgstr "You haven't written a note."

#: src/pages/profile/bio-section.tsx
msgid "You haven't written anything about yourself yet."
msgstr "You haven't written anything about yourself yet."

#: src/pages/events/details/participation.tsx
msgid "You'll be notified of new comments."
msgstr "You'll be notified of new comments."

#: src/pages/events/details/participation.tsx
msgid "You're coming"
msgstr "You're coming"

#: src/pages/events/details/participation.tsx
msgid "You're not coming"
msgstr "You're not coming"

#: src/pages/profile/bio-section.tsx
msgid "Your activities, what you like to share or to learn"
msgstr "Your activities, what you like to share or to learn"

#: src/pages/home/profile-completion/05-address-step.tsx
msgid "Your address"
msgstr "Your address"

#: src/pages/events/details/participation.tsx
#: src/pages/requests/details/request-answer.tsx
msgid "Your answer couldn't be saved"
msgstr "Your answer couldn't be saved"

#: src/pages/home/home-page.tsx
msgid "Your balance: {balance}"
msgstr "Your balance: {balance}"

#: src/pages/settings/settings-page.tsx
msgid "Your changes are only kept in this browser."
msgstr "Your changes are only kept in this browser."

#: src/pages/events/edit/edit-event-page.tsx
#: src/pages/information/edit/edit-information-page.tsx
#: src/pages/profile/profile-section.tsx
#: src/pages/requests/edit/edit-request-page.tsx
msgid "Your changes couldn't be saved"
msgstr "Your changes couldn't be saved"

#: src/pages/home/profile-completion/step-layout.tsx
msgid "Your changes couldn't be saved. Try again in a few moments."
msgstr "Your changes couldn't be saved. Try again in a few moments."

#: src/components/comments-section.tsx
msgid "Your comment couldn't be posted"
msgstr "Your comment couldn't be posted"

#: src/pages/events/details/organizer-actions.tsx
msgid "Your event"
msgstr "Your event"

#: src/pages/members/details/exchanges-tab.tsx
msgid "Your exchanges will appear here."
msgstr "Your exchanges will appear here."

#: src/pages/help/help-page.tsx
msgid "Your feedback helps us improve the application."
msgstr "Your feedback helps us improve the application."

#: src/pages/information/details/information-details-page.tsx
msgid "Your information"
msgstr "Your information"

#: src/pages/interests/membership.tsx
msgid "Your note couldn't be saved"
msgstr "Your note couldn't be saved"

#: src/pages/interests/membership.tsx
msgid "Your note was saved"
msgstr "Your note was saved"

#: src/pages/home/open-requests-card.tsx
msgid "Your open requests"
msgstr "Your open requests"

#: src/pages/profile/contact-section.tsx
msgid "Your phone number can't be removed, only changed"
msgstr "Your phone number can't be removed, only changed"

#: src/pages/requests/details/requester-actions.tsx
msgid "Your request"
msgstr "Your request"

#: src/pages/requests/create/create-request-page.tsx
msgid "Your request couldn't be posted"
msgstr "Your request couldn't be posted"

#: src/pages/members/details/activity-tab.tsx
msgid "Your requests, events and offers to help will appear here."
msgstr "Your requests, events and offers to help will appear here."
